function getSmartSrc(sourceEl, width) {
  const smartsrc = sourceEl.dataset.smartsrc;
  const backupsrc = sourceEl.dataset.backupsrc;
  if (!smartsrc) return backupsrc;
  const displayWidth = width;
  const candidates = smartsrc.split(',').map(s => {
    const [url, w] = s.trim().split(' ');
    return { url, width: parseInt(w) };
  });
  candidates.sort(
    (a, b) => Math.abs(a.width - displayWidth) - Math.abs(b.width - displayWidth)
  );
  return candidates[0]?.url || backupsrc;
}

function smartvid() {
  $('.smartvid').each(function () {
    const $module = $(this);
    const $sources = $module.find('source');
    const videoEl = $module[0];


    /*
    ** HANDLE PLAY/PAUSE AUTOPLAY
    */
    let userPaused = false;
    videoEl.addEventListener('pause', () => {userPaused = true;});
    videoEl.addEventListener('play',  () => {userPaused = false;});

    /*
    ** RESIZE
    */
    const debounceResize = _.debounce(calc, 400);
    function calc() {
      bus.emit('video.change.will', videoEl)

      const width = $module.outerWidth();
      let changed = false;

      $sources.each(function () {
        const currentSrc = $(this).attr('src');
        const newSrc = getSmartSrc(this, width);

        if (currentSrc !== newSrc) {
          $(this).attr('src', newSrc);
          changed = true;
        }
      });

      if (changed) {
        const wasPaused = videoEl.paused;
        const currentTime = videoEl.currentTime;


        if (userPaused) {
          videoEl.removeAttribute('autoplay');
        }

        videoEl.load();

        videoEl.addEventListener('loadedmetadata', function restore() {
          bus.emit('video.change.did', videoEl)
          videoEl.removeEventListener('loadedmetadata', restore);

          if (!isNaN(currentTime) && currentTime > 0) {
            videoEl.currentTime = Math.min(currentTime, videoEl.duration || currentTime);
          }

          if (!wasPaused && !userPaused && videoEl.hasAttribute('autoplay')) {
            const playPromise = videoEl.play();
            if (playPromise) playPromise.catch(() => {});
          }

        });
      } else {
        bus.emit('video.change.didnt', videoEl)
      }
    }

    /*
    ** EVENTS
    */
    function eventOn() {
      bus.on('pageLeaveEnd', eventOff);
      bus.on('resize', debounceResize);
    }
    function eventOff() {
      bus.off('pageLeaveEnd', eventOff);
      bus.off('resize', debounceResize);
    }

    /*
    ** INIT
    */
    eventOn();
    calc();
  });
}



export default smartvid;
